import { TwitterTweetButtonInterface } from 'common/types/entities/TwitterTweetButtonInterface'
import styled from 'styled-components'

const TwitterTweetButtonUi = styled.a<
  Pick<TwitterTweetButtonInterface, 'alignSelf' | 'mobileAlignSelf'>
>`
  display: flex;
  align-items: center;
  background-color: #000;
  color: #ffffff;
  padding: 5px 12px 5px 10px;
  border-radius: 15px;
  font-size: 13px;
  font-family: 'Helvetica Neue', Arial, sans-serif;
  text-decoration: none;
  > span {
    margin-left: 4px;
  }
  &:hover {
    background-color: #000;
  }

  ${({ alignSelf }) => `align-self: ${alignSelf};`}
  ${p => p.theme.phone} {
    ${({ mobileAlignSelf }) => `align-self: ${mobileAlignSelf}`}
  }
`

export default TwitterTweetButtonUi
